import DialogWithCloseButton from 'components/DialogWithCloseButton'
import { QuizIcon } from 'components/ReusableComponents/Icons/QuizIcon'
import { useState } from 'react'

import styles from '../MultiStepPMSLogin.module.scss'
import { faqQuestions } from './constants'
import FindHubId from './solutions/FindHubId'
import FindPropertyId from './solutions/FindPropertyId'
import InterfaceIdAndKey from './solutions/InterfaceIdAndKey'
import LoginURL from './solutions/LoginURL'

const FAQCard = ({ selectedStep }) => {
  const [displayedQuestion, setDisplayedQuestion] = useState(null)

  const handleClose = () => {
    setDisplayedQuestion(null)
  }

  return (
    <div className={styles.faqCard}>
      {displayedQuestion && (
        <DialogWithCloseButton
          title={displayedQuestion.text}
          handleClose={handleClose}
          className={styles.contentWrapper}
        >
          <div className={styles.dialogContent}>
            {displayedQuestion.id === 1 && <FindHubId />}
            {displayedQuestion.id === 2 && <LoginURL />}
            {displayedQuestion.id === 3 && <FindPropertyId />}
            {displayedQuestion.id === 4 && <InterfaceIdAndKey />}
          </div>
        </DialogWithCloseButton>
      )}
      <div className={styles.titleContainer}>
        <span className={styles.cardIcon}>
          <QuizIcon />
        </span>
        <p className={styles.cardTitle}>FAQ</p>
      </div>
      <div className={styles.questionsContainer}>
        {faqQuestions
          .filter(question => question.step === selectedStep)
          .map(question => (
            <p
              key={question.id}
              className={styles.question}
              onClick={() => setDisplayedQuestion(question)}
            >
              {question.text}
            </p>
          ))}
      </div>
    </div>
  )
}

export default FAQCard
